import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
	selector: "device-conflict-modal",
	template: `
		<modal (close)="onModalClosed()">
			<header class="modal_header">
				<h2 class="text-center">Device Conflict</h2>
			</header>
			<div class="modal_body">
				<p>
					{{ conflictDetails }}
				</p>
			</div>
			<footer class="modal_footer">
				<div class="modal_buttons">
					<button
							class="button button-primary py-1 px-6"
							(click)="onModalClosed()">
						OK
					</button>
				</div>
			</footer>
		</modal>
	`,
})
export class DeviceConflictModalComponent {
	@Input() conflictDetails: string;
	@Output() modalClosed = new EventEmitter();

	onModalClosed() {
		this.modalClosed.emit()
	}
}
